import { render, staticRenderFns } from "./create.vue?vue&type=template&id=76edd2cb&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=76edd2cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76edd2cb",
  null
  
)

export default component.exports